// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"241":"swaps","296":"privacy","480":"disclaimer","609":"bridge","720":"faq","929":"terms"}[chunkId] || chunkId) + "." + {"241":"ab52c804","296":"57417a29","480":"0df575eb","609":"b9818a9b","685":"51814d23","720":"ebdd65f0","929":"2b8c1393"}[chunkId] + ".css";
};